import {http} from '@/src/services/config/config-receituario'

export default{
    reportAdabExcel:(token, startDate, endDate, art = '')=>{
        const params = []

        if (startDate) {
            params.push(`startDate=${encodeURIComponent(startDate)}`)
        }
        if (endDate) {
            params.push(`endDate=${encodeURIComponent(endDate)}`)
        }
        if (art) {
            params.push(`art=${encodeURIComponent(art)}`)
        }

        const query = params.length ? `?${params.join('&')}` : ''

        return http.get(`webservices/adab/excel${query}`, {
            headers:{
                'Authorization':token
            },
            responseType: 'blob',
        })
    },
    reportCfta:(token, dataIni, dataFim, art = '')=>{
        const params = []

        if (dataIni) {
            params.push(`startDate=${encodeURIComponent(dataIni)}`)
        }
        if (dataFim) {
            params.push(`endDate=${encodeURIComponent(dataFim)}`)
        }
        if (art) {
            params.push(`art=${encodeURIComponent(art)}`)
        }

        const query = params.length ? `?${params.join('&')}` : ''

        return http.get(`webservices/cfta${query}`, {
            headers:{
                'Authorization':token
            }
        })
       
    },
    reportSiagro:(token, dataIni, dataFim)=>{
        return http.get(`webservices/siagro?startDate=${dataIni}&endDate=${dataFim}`, {
            headers:{
                'Authorization':token
            }
        })
    },
    syncSigen:(token, dataIni, dataFim)=>{
        return http.post('webservices/sigen/sync', {
            startDate: dataIni,
            endDate: dataFim,
        }, {
            headers:{
                'Authorization':token
            }
        })
    },
}
